module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_11-41f3ce0d14b89af51203b67ea656c440.png";